import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/TopNavBar.scss';

function TopNavBar() {
    const [isOpen, setIsOpen] = useState(false);
    const navRef = useRef();
    const toggleMenu = () => setIsOpen(!isOpen);

    // return (
    // <nav className="top-navbar">
    //     <div className="logo"><a href='/'><img className='logo-img' src='/assets/crispy-logo-crop.png'/></a></div>
    //     <div className={`nav-links ${isOpen ? 'open' : ''}`}>
    //         <Link to="/">Home</Link>
    //         <Link to="/about">About</Link>
    //         <Link to="/menu">Menu</Link>
    //     </div>
    //     <div className="burger" onClick={toggleMenu}>
    //         <div className="line"></div>
    //         <div className="line"></div>
    //         <div className="line"></div>
    //     </div>
    // </nav>

    // );



    const handleClickOutside = (event) => {
        if (navRef.current && !navRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen]);

    return (
        <nav className="top-navbar" ref={navRef}>
            <div className="logo">
                <a href='/'><img src="/assets/crispy-logo-crop.png" alt="Logo" className="logo-img" /></a>
            </div>


            <div className={`nav-links ${isOpen ? 'open' : ''}`}>
                <Link to="/" onClick={() => setIsOpen(false)}>Home</Link>
                <Link to="/about" onClick={() => setIsOpen(false)}>About</Link>
                <Link to="/menu" onClick={() => setIsOpen(false)}>Menu</Link>
            </div>

            <div className="burger" onClick={toggleMenu}>
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
            </div>
        </nav>
    );


}

export default TopNavBar;
